import { Typography, useTheme } from "@mui/material";
import { t } from "i18next";

type Props = {
  hits: number;
  total: number;
};

const SearchResult = (props: Props) => {
  const theme = useTheme();

  return (
    <Typography
      variant="h5"
      component="h6"
      color={theme.palette.base.contrast}
      sx={{ fontSize: "20px" }}
    >
      {t("SEARCH_RESULTS")}
      {`${props.hits}/${props.total}`}
      {t("CASES")}
    </Typography>
  );
};

export default SearchResult;
